module.exports = __webpack_public_path__ + "fonts/TildaSans-Semibold.ae0f3e5.ttf";